import React from "react";
import type { IconButtonProps } from "@mui/joy";
import { IconButton } from "@mui/joy";
import type { SxProps } from "@mui/joy/styles/types";
import {
  ctaIconButtonDisabledSx,
  ctaVariantEnabledSxMap,
  joyIconButtonColorByCtaVariant,
} from "../../styles/globalStyles";
import type { CtaVariant } from "../../styles/globalStyles";

export interface IconButtonCTAProps extends Omit<IconButtonProps, "aria-label"> {
  "aria-label": string;
  ctaVariant?: CtaVariant;
}

const IconButtonCTA = React.forwardRef<HTMLButtonElement, IconButtonCTAProps>(
  function IconButtonCTA(
    { "aria-label": ariaLabel, ctaVariant = "accent", color, sx, variant = "plain", ...props },
    ref,
  ) {
    const joyColor = color ?? joyIconButtonColorByCtaVariant[ctaVariant];
    const usesHexCtaPalette = color === undefined;

    const resolvedSx: SxProps = [
      { flexShrink: 0 },
      usesHexCtaPalette ? ctaVariantEnabledSxMap[ctaVariant] : {},
      sx ?? {},
      ctaIconButtonDisabledSx,
    ] as SxProps;

    return (
      <IconButton
        ref={ref}
        {...props}
        aria-label={ariaLabel}
        sx={resolvedSx}
        variant={variant}
        color={joyColor}
      />
    );
  },
);

export default IconButtonCTA;
